import { render, staticRenderFns } from "./splitPane.vue?vue&type=template&id=8fc5e74c&scoped=true"
import script from "./splitPane.vue?vue&type=script&lang=js"
export * from "./splitPane.vue?vue&type=script&lang=js"
import style0 from "./splitPane.vue?vue&type=style&index=0&id=8fc5e74c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc5e74c",
  null
  
)

export default component.exports